import { Context, failure, success, Type, Validation } from 'io-ts';

export const JsonEncode = new Type<unknown, string, string>(
    'JsonEncode',
    is,
    validate,
    encode,
);

function is(value: unknown): value is unknown {
    return true;
}

function validate(input: string, context: Context): Validation<unknown> {
    try {
        return success(JSON.parse(input));
    } catch {
        return failure(input, context, 'Malformed JSON');
    }
}

function encode(value: unknown): string {
    return JSON.stringify(value);
}
